import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
   constructor(private applicationInsightsService: ApplicationInsightsService) {
      super();
   }

   handleError(error: Error) {
      try {
         this.applicationInsightsService.logException(error);
         if (!environment.production) {
            console.error(error);
         }
      } catch (loggingError) {
         if (!environment.production) {
            console.error(loggingError);
         }
      }
      super.handleError(error);
   }
}
